export function windowStickerGenerator() {
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('#windowssticker');
    const carBrand = form.querySelector('#windowsstickerMake');
    const vinNumber = form.querySelector('#windowsstickerVin');
    let url = "";

    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      console.log('submit');

      switch (carBrand.value) {
        case 'buick':
          url = "https://cws.gm.com/vs-cws/vehshop/v2/vehicle/windowsticker?vin=";
          break;
  
        case 'cadillac':
          url = "https://cws.gm.com/vs-cws/vehshop/v2/vehicle/windowsticker?vin=";
          break;
  
        case 'chevrolet':
          url = "https://cws.gm.com/vs-cws/vehshop/v2/vehicle/windowsticker?vin=";
          break;
  
        case 'chrysler':
          url = "https://www.chrysler.com/hostd/windowsticker/getWindowStickerPdf.do?vin=";
          break;
  
        case 'dodge':
          url = "https://www.dodge.com/hostd/windowsticker/getWindowStickerPdf.do?vin=";
          break;
  
        case 'gmc':
          url = "https://cws.gm.com/vs-cws/vehshop/v2/vehicle/windowsticker?vin=";
          break;
  
        case 'fiat':
          url = "https://www.fiatusa.com/hostd/windowsticker/getWindowStickerPdf.do?vin=";
          break;
  
        case 'genesis':
          url = "https://prevapp.hyundaiusa.com/DealerExternalService.svc/Monroney/pdf/GetMonroneyLabelPDF?VIN=";
          break;
  
        case 'hyundai':
          url = "https://prevapp.hyundaiusa.com/DealerExternalService.svc/Monroney/pdf/GetMonroneyLabelPDF?VIN=";
          break;
  
        case 'jeep':
          url = "https://www.jeep.com/hostd/windowsticker/getWindowStickerPdf.do?vin=";
          break;
  
        case 'ford':
          url = "http://www.inventory.ford.com/services/inventory/WindowSticker.pdf?vin=";
          break;
  
        case 'ram':
          url = "https://www.ramtrucks.com/hostd/windowsticker/getWindowStickerPdf.do?vin=";
          break;
      }

      
      console.log(carBrand.value, 'carBrand');
      console.log(vinNumber.value, 'vinNumber');

      window.open(url + vinNumber.value, '_blank');
    });
  });
}